import { Component, Mixins } from '@/vue-property-decorator'
import {
  _CssVarCustom as CssVarCustom,
  _CssVarManagerBase
} from './cssVarCustom'
import { _CssVarDefault as CssVarDefault } from './cssVarDefault'
import { GetCssVarManager } from '../../../components/baseCssVarProvide'
import AdvertisementImgBox from '../components/advertisementImgBox'
import BaseCssVarInject from '../../../components/baseCssVarInject'
import BasePropsConfig from '../components/basePropsConfig'
import BoxCut, { BoxCutBase } from '../../components/boxCut'
import FallbackBackground from '../../components/fallbackBackground'
import FavoriteIcon from '../../components/favoriteIcon'
import GameNameBold from './gameNameBold'
import LabelGameStatus from '../../components/labelGameStatus'
import MaskMaintain, { MaskMaintainBase } from '../../components/maskMaintain'
import OuterBox from '../components/outerBox'
/** 该卡片的类型声明 */
export type SquareGalaxyCssVarManager = GetCssVarManager<_CssVarManagerBase>
export { CssVarDefault }
/** 暴露的子组件cssVar */
type SubCssVarBase = {
  boxCut?: BoxCutBase
  maskMaintainBase?: MaskMaintainBase
}
/** 游戏卡片-标准版
 * 上方正方型图片,下方结合文字
 */
@Component<SquareGalaxy>({
  name: 'SquareGalaxy'
})
export default class SquareGalaxy extends Mixins<
  // eslint-disable-next-line @typescript-eslint/ban-types
  BaseCssVarInject<{ cssType: string }, SubCssVarBase>,
  BasePropsConfig
>(BaseCssVarInject, BasePropsConfig) {
  /** 基础cssVarManager的抽象基类 */
  public static CssVarManagerBase = _CssVarManagerBase
  /** css的自定义样式 */
  public static CssVarCustom = CssVarCustom
  /** 默认样式 */
  public static CssVarDefault = CssVarDefault
  /** 获得props */
  public static getProps = BasePropsConfig.getProps

  // 渲染入口.
  render() {
    const { isFavorited, isMaintain, isShowFavorited } = this.cardProps
    const { status } = this.cardProps
    return (
      <OuterBox
        class={{ 'square-galaxy': true }}
        onClick={this.handleClickCard}
      >
        {/* 裁剪盒子 */}
        <BoxCut cssPriority="self">
          {/* 卡片主体基础内容 */}
          <AdvertisementImgBox>
            <template slot="logoSlot">
              <AdvertisementImgBox.LogoHasBackground />
            </template>
          </AdvertisementImgBox>
          {/* 将被裁剪的悬浮元素 */}
          <template slot="cutSuspense">
            {/* 兜底背景图 */}
            <FallbackBackground />
            {/* 广告状态 */}
            {(status && this.$scopedSlots.labelGameStatus?.()) || (
              <LabelGameStatus status={status} />
            )}
            {isMaintain && <MaskMaintain />}
            {/* 银河金收藏图标特殊一点,也希望被overflow:hidden裁剪 */}
            {isShowFavorited && (
              <FavoriteIcon
                isFavorited={isFavorited}
                onClick={this.handleClickFavorIcon}
              >
                <FavoriteIcon.TriangleHeart />
              </FavoriteIcon>
            )}
          </template>
        </BoxCut>
        {/* 游戏名称 */}
        <GameNameBold></GameNameBold>
      </OuterBox>
    )
  }
}
